import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { appRoutes } from './app.routes';
import { authInterceptor } from '@shared-data-access';
import { ConfigService } from '@shared-data-access';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    ConfigService,
    // API_CONFIG se elimina de aquí porque ya usa `providedIn: 'root'` en api-config.ts
    // Si necesitás sobreescribirlo, usá: { provide: API_CONFIG, useValue: {...} }
  ],
};
